<template>
  <div class="container-fluid">
    <div class="row">
      <div
        role="main"
        class="col d-block"
      >
        <section class="d-flex justify-content-between align-items-center mt-2">
          <div class="section-title py-0">
            Locations Verification
          </div>
        </section>
        <hr>
        <div class="row">
          <div class="col">
            <button
              type="submit"
              class="btn btn-outline-primary"
              @click="runVerification"
              :disabled="loading"
            >
              <template v-if="loading">
                Loading...
              </template>
              <template v-else>
                Run
              </template>
            </button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="mb-2 text-monospace d-flex">
              Verification Results
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm text-primary ml-2"
                role="status"
              />
            </p>
            <ul
              v-if="processOutput"
              class="list-group mb-4"
            >
              <li
                v-for="result in processOutput.results"
                :key="result.name"
                :class="`list-group-item ${result.passed ? 'list-group-item-success' : 'list-group-item-danger'}`"
              >
                <p class="font-weight-bold m-0 d-flex justify-content-between">
                  {{ result.name }} <span class="font-weight-normal">{{ parseFloat( result.timeTaken ).toPrecision( 2 ) }}s</span>
                </p>
                <table
                  v-if="result.failures"
                  class="table table-responsive mt-2 mb-0"
                >
                  <thead>
                    <tr>
                      <td
                        v-for="key in Object.keys(result.failures[ 0 ])"
                        :key="key"
                        class="font-weight-bold"
                      >
                        {{ key }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(entry, i) in result.failures"
                      :key="i"
                    >
                      <td
                        v-for="(value, j) in Object.values(entry)"
                        :key="j"
                      >
                        {{ value }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notify from '../../notifications';

export default {
    data() {
        return {
            loading: false,
            processOutput: null
        };
    },
    methods: {
        async runVerification() {
            this.loading = true;

            this.processOutput = null;

            const response = await fetch( `${process.env.GEO_SERVICE_URL}/verify` );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Verification process failed with status ' + response.status,
                    title: 'Verification Failed'
                } );
                this.verification.loading = false;
                return;
            }

            const output = await response.json();

            this.processOutput = output;

            if ( this.processOutput.results ) {
                this.processOutput.results.sort( ( a, b ) => {
                    if ( a.passed && b.passed ) {
                        return a.timeTaken - b.timeTaken;
                    }
                    if ( a.passed ) {
                        return 1;
                    }
                    return -1;
                } );
            }

            this.loading = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/locations/Verification.vue